import React from 'react';
import { Table } from "react-bootstrap";
import BasicPagination from '../../pagination/BasicPagination';

export const TicketTable = ({ handleShow1, ticketList, limit, skip, onPageChange }) => {
    return (
        <div className="tblmrgn mt-0">
           
            <Table hover responsive className="mb-0 default_table mrpdng_tbl with_hoverbtn">
                <thead>
                    <tr>
                        <th className="wd-120">Date and Time</th>
                        <th>Ticket No.</th>
                        <th>Subject</th>
                        <th>Details</th>
                        <th>Status</th>
                        <th className="wd-120"></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ticketList && ticketList.data && ticketList.data.length ? (
                            ticketList.data.map(dt => (
                                <tr key={dt._id}>
                                    <td>{new Date(dt.createdAt).toLocaleString()}</td>
                                    <td>{dt.ticketNo}</td>
                                    <td>{dt.subject}</td>
                                    <td>
                                        <span className="elpt_txt">{dt.message}</span>
                                    </td>
                                    <td className="pngng_stt">{dt.status}</td>
                                    <td>
                                        <button type="button" onClick={() => handleShow1(dt)} className="btn_new btn-sm dtld_btn">Details</button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">
                                    No Record Found
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
            <div className="row d-flex align-items-center mr-5 ml-5 mt-5">
                <div className="col-md-4 mb-5 fn_s_16 f-w-400">
                    Displaying {(skip * limit) + 1} - {((skip * limit)) + limit} of {ticketList.recordsTotal} Records
                            </div>
                <div className="col-md-4 text-center mb-5 algnlft676">
                </div>
                <div className="col-md-4 text-right mb-5 aspgntn">
                    <BasicPagination
                        totalRecords={ticketList.recordsTotal}
                        limit={limit}
                        batch={skip + 1}
                        onBatchChange={onPageChange}
                    />
                </div>
            </div>
        </div>
    )
}